import React from "react";
import { WorkspaceTodoItemRowContainer } from "./WorkspaceTodoItemRowContainer";
import { graphql, useFragment } from "react-relay";
import { WorkspaceTodoListItem_todo$key } from "./__generated__/WorkspaceTodoListItem_todo.graphql";
import { View } from "react-native";
import { AHText, Box, ListItem, TodoPrioIcon } from "arkh";
import { WorkspaceTodoDetailIndicator } from "./DraftIndicator";

import { WorkspaceTodoListItemStatus } from "./WorkspaceTodoListItemStatus";
import { WorkspaceTodoListItemDescription } from "./WorkspaceTodoListItemDescription";
import { FormattedDateInWorkspace } from "../../../common/dates/FormattedDate";
import { WorkspaceDifferentOwnerIndicator } from "../WorkspaceDifferentOwnerIndicator";

export function WorkspaceTodoListItem(props: {
  workspaceTodo: WorkspaceTodoListItem_todo$key;
  isLast?: boolean;
  isFirst?: boolean;
  onPressEdit: (todoWorkspaceId: string) => void;
  onPress: (todoWorkspaceId: string) => void;
  showTopics: boolean;
}) {
  const workspaceTodo = useFragment(
    graphql`
      fragment WorkspaceTodoListItem_todo on TodoWorkspace {
        id
        expireAtDate {
          ...FormattedDate
        }
        scheduledPublishAt {
          ...FormattedDate
        }
        publishedAtDate {
          ...FormattedDate
        }
        status
        topic {
          id
          name
        }
        workspaceOwnerName(workspaceId: $workspaceId)
        priority
        ...WorkspaceTodoListItemStatus_todo
        ...WorkspaceTodoListItemDescription_todo
      }
    `,
    props.workspaceTodo
  );
  return (
    <ListItem
      displayMode="TABLE"
      onPress={() => {
        if (
          workspaceTodo.status === "DRAFT" ||
          workspaceTodo.status === "SCHEDULED"
        ) {
          props.onPressEdit(workspaceTodo.id);
        } else {
          props.onPress(workspaceTodo.id);
        }
      }}
      isLast={props.isLast}
      isFirst={props.isFirst}
      border="border-primary"
    >
      <WorkspaceDifferentOwnerIndicator
        name={workspaceTodo.workspaceOwnerName}
      />

      <WorkspaceTodoItemRowContainer
        priority={<TodoPrioIcon priority={workspaceTodo.priority} />}
        description={
          <WorkspaceTodoListItemDescription workspaceTodo={workspaceTodo} />
        }
        published={
          workspaceTodo.status === "DRAFT" ||
          workspaceTodo.status === "SCHEDULED" ? (
            <Box style={{ flexDirection: "column" }}>
              <WorkspaceTodoDetailIndicator status={workspaceTodo.status} />
              {workspaceTodo.status === "SCHEDULED" &&
              workspaceTodo.scheduledPublishAt ? (
                <AHText spaceTop="xxsmall" type="detail" color="text-secondary">
                  <FormattedDateInWorkspace
                    date={workspaceTodo.scheduledPublishAt}
                  />
                </AHText>
              ) : null}
            </Box>
          ) : (
            <AHText numberOfLines={1}>
              {workspaceTodo.publishedAtDate ? (
                <FormattedDateInWorkspace
                  date={workspaceTodo.publishedAtDate}
                />
              ) : null}
            </AHText>
          )
        }
        topic={
          props.showTopics ? (
            <AHText numberOfLines={1}>
              {workspaceTodo.topic ? workspaceTodo.topic.name : null}
            </AHText>
          ) : null
        }
        deadline={
          <AHText numberOfLines={1}>
            {workspaceTodo.expireAtDate ? (
              <FormattedDateInWorkspace date={workspaceTodo.expireAtDate} />
            ) : null}
          </AHText>
        }
        status={<WorkspaceTodoListItemStatus workspaceTodo={workspaceTodo} />}
        more={<View />}
      />
    </ListItem>
  );
}
